/**
 * 计算同 task 下与 anchorId 处于同血缘链的所有 asset。
 * 用于版本切换器:从某 asset 上溯到根原图,再下溯到所有派生版本。
 *
 * originAssetId 是版本链根 asset id(语义上多次重画后所有 derivative 都指向同一个根)。
 */
import type { PosterAssetDto } from "../../../api/posterService";

function getParentId(a: PosterAssetDto): number | null {
  return a.originAssetId ?? null;
}

export function buildVersionChain(all: PosterAssetDto[], anchorId: number): PosterAssetDto[] {
  const byId = new Map(all.map((a) => [a.id, a]));
  const chain = new Set<number>();
  // 上溯到根
  let cur: PosterAssetDto | undefined = byId.get(anchorId);
  while (cur) {
    chain.add(cur.id);
    const pid = getParentId(cur);
    cur = pid ? byId.get(pid) : undefined;
  }
  // 下溯:任何 parent 在 chain 内的也加入
  let added = true;
  while (added) {
    added = false;
    for (const a of all) {
      if (chain.has(a.id)) continue;
      const pid = getParentId(a);
      if (pid && chain.has(pid)) {
        chain.add(a.id);
        added = true;
      }
    }
  }
  return all.filter((a) => chain.has(a.id));
}
